import ApiLayout from '@uxcore/layouts/ApiLayout/ApiLayout';

export default ApiLayout;
